<template>
  <div class="signup-container">
    <v-form v-model="isValid" class="signup-content">
      <span class="main-title">Sign Up</span>

      <v-text-field
        label="Name"
        placeholder="Enter your name"
        :rules="[v => !!v || 'Name is required']"
        v-model="user_name"
      />

      <v-text-field
        label="Email"
        placeholder="Enter your email address"
        :rules=" [
          v => !!v || 'Email is required',
          v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ]"
        v-model="user_email"
      />

      <v-text-field
        label="Password"
        placeholder="Enter your password"
        type="password"
        :rules="[v => !!v || 'Password is required']"
        v-model="user_password"
      />

      <v-btn rounded
             class="ma-auto"
             color="#def7ff"
             @click="signUpUser"
             :disabled="!isValid"
      >Signup
      </v-btn>
      <span>
        Already have an account?
        <span class="login-link"
              @click="$emit('logOut')"
        >
          login
        </span>
      </span>
    </v-form>

  </div>
</template>

<script>
import Api from "@/services/api";

export default {
  name: "signup",
  data: () => ({
    api: "",
    user_name: "",
    user_email: "",
    user_password: "",
    isValid: true
  }),

  methods: {
    async signUpUser() {
      await this.api.signup(this.user_name, this.user_email, this.user_password);
      await this.$router.push('/login')
    },
  },

  async created() {
    this.api = new Api;
  }
}

</script>

<style scoped>
.main-title {
  text-align: center;
  font-size: 4vh;
  padding-bottom: 2vh;
  font-style: italic;
}

.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.signup-content {
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;
  padding: 3vh;
  margin: 2vh;
  width: max(50vh, 60vw);
  border-radius: 15px;
}

.login-link {
  color: blue;
}

.login-link:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
